import BrandedSuccessLottie from "@/components/ui/BrandedSuccessLottie";
import PageTransition from "@/components/ui/PageTransition";
import { XIcon } from "lucide-react";
import React from "react";

interface SuccessScreenProps {
	title: string | React.ReactNode;
	description: string | React.ReactNode;
	onClose?: () => void;
	children: React.ReactNode;
}

const SuccessScreen: React.FC<SuccessScreenProps> = ({
	title,
	description,
	onClose,
	children,
}) => {
	return (
		<PageTransition>
			<div className="text-center max-w-lg mx-auto">
				{onClose && (
					<XIcon
						className="absolute top-2 right-2"
						role="button"
						onClick={onClose}
					/>
				)}
				<div className="max-w-64 mx-auto ">
					<BrandedSuccessLottie />
				</div>

				<div className="w-full text-center">
					<h1 className="text-4xl font-bold text-textDark">{title}</h1>
					<p className="pt-3 text-sm font-medium text-textDark pb-9">
						{description}
					</p>
				</div>
				<div className="mt-6">{children}</div>
			</div>
		</PageTransition>
	);
};

export default SuccessScreen;
